import { Pipe, PipeTransform } from '@angular/core';

import { CalendarEvent } from 'angular-calendar';

@Pipe({
    name: 'calendarEventsLimitFilter',
    pure: false
})
export class CalendarEventsLimitFilterPipe implements PipeTransform {
    transform(events: CalendarEvent[] = [], limit = -1): CalendarEvent[] {
        if (limit === -1) {
            return events;
        }

        return events.filter((event, index) => {
            if (index < limit) {
                return event;
            }
        });
    }
}
